import { PropsWithChildren } from 'react'
import classnames from 'classnames'

import './style.scss'

type SpinProps = PropsWithChildren<{
  spinning: boolean
  className?: string
}>

const prefixCls = 'eufy'

function Spin(props: SpinProps) {
  const { spinning, children } = props

  // 区分是嵌套还是单独使用
  if (Object.prototype.hasOwnProperty.call(props, 'children')) {
    return (
      <div className={`${prefixCls}-spin-nested-loading`}>
        <div
          className={classnames(
            `${prefixCls}-spin`,
            { [`${prefixCls}-spinning`]: spinning },
          )}
        >
          <i />
        </div>
        <div
          className={classnames(
            `${prefixCls}-spin-container`,
            { [`${prefixCls}-spin-blur`]: spinning },
          )}
        >
          {children}
        </div>
      </div>
    )
  }

  return (
    <div
      className={classnames(
        `${prefixCls}-spin`,
        { [`${prefixCls}-spinning`]: spinning },
      )}
    >
      <i />
    </div>
  )
}

Spin.defaultProps = {
  spinning: true
}

export default Spin
